import React from "react";
import CustomerPortalSkeleton from "./../../../molecules/CustomerPortalSkeleton";
import CustomerPortalEditSkeleton from "./../../../molecules/CustomerPortalEditSkeleton";
import styled from "styled-components";

const Wrap = styled.div`
  max-width: ${(props) => props.theme.sizes.maxWidth};
  margin: 0 auto;
  padding-top: 22px;
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 990px) {
    padding-top: 90px;
  }
`;

export default function Loaders(props) {
  const { upcomingDeliveryMeals, redirectEditQuantity, isCustomerActive, orderAndChargeDataReceived } = props;
  return (
    <>
      {upcomingDeliveryMeals.length === 0 && !redirectEditQuantity && isCustomerActive === null && orderAndChargeDataReceived === null && (
        <Wrap>
          <CustomerPortalSkeleton />
        </Wrap>
      )}
      {upcomingDeliveryMeals.length === 0 && redirectEditQuantity && orderAndChargeDataReceived !== false && (
        <Wrap>
          <CustomerPortalEditSkeleton />
        </Wrap>
      )}
    </>
  );
}
